<p class="govuk-hint" *ngIf="loading()">Načítavam detail správy…</p>

<div class="govuk-error-summary" *ngIf="error()">
  <div class="govuk-error-summary__body">
    <p class="govuk-body">{{ error() }}</p>
  </div>
</div>

<article *ngIf="detail() as msg" class="govuk-!-margin-bottom-6">
  <h2 class="govuk-heading-m govuk-!-margin-bottom-3">Detail správy</h2>



  <dl class="govuk-summary-list app-detail-info">
    <div class="govuk-summary-list__row">
      <dt class="govuk-summary-list__key">Odosielateľ</dt>
      <dd class="govuk-summary-list__value">{{ sender() || '' }}</dd>
    </div>
    <div class="govuk-summary-list__row" *ngIf="msg.SenderBusinessReference">
      <dt class="govuk-summary-list__key">Odosielateľ – referencia</dt>
      <dd class="govuk-summary-list__value">{{ msg.SenderBusinessReference }}</dd>
    </div>
    <div class="govuk-summary-list__row">
      <dt class="govuk-summary-list__key">Príjemca</dt>
      <dd class="govuk-summary-list__value">{{ recipient() || '' }}</dd>
    </div>
    <div class="govuk-summary-list__row" *ngIf="msg.RecipientBusinessReference">
      <dt class="govuk-summary-list__key">Príjemca – referencia</dt>
      <dd class="govuk-summary-list__value">{{ msg.RecipientBusinessReference }}</dd>
    </div>
  </dl>

  <div class="app-detail-section">
    <h3 class="govuk-heading-s">Text správy</h3>
    <div class="app-message-body govuk-body" [innerHTML]="safeBody()"></div>
  </div>

  <div class="app-detail-section app-attachments-section">
    <h3 class="govuk-heading-s">Prílohy</h3>
    <div class="app-table-scroll app-attachments">
      <table class="govuk-table">
        <colgroup>
          <col class="col-file">
          <col class="col-actions">
        </colgroup>

        <thead class="govuk-table__head">
          <tr class="govuk-table__row">
            <th class="govuk-table__header" scope="col">Súbor</th>
            <th class="govuk-table__header" scope="col">Akcie</th>
          </tr>
        </thead>

        <tbody class="govuk-table__body">
          <tr class="govuk-table__row" *ngFor="let a of msg.Parts">
            <td class="govuk-table__cell">
              <span class="filename">{{ a.Name }}</span>
              <div class="govuk-hint" *ngIf="a.Description">{{ a.Description }}</div>
              <div class="attachment-type-info" [title]="a.MimeType">
                <span class="govuk-hint govuk-!-font-size-14">{{ a.MimeType }}</span>
                <ng-container *ngIf="a.Class"> · {{ a.Class }}</ng-container>
                <ng-container *ngIf="a.IsSigned"> · podpísané</ng-container>
              </div>
            </td>

            <td class="govuk-table__cell actions">
              <button type="button"
                      class="govuk-button govuk-button--secondary govuk-button--small govuk-!-margin-bottom-0"
                      (click)="download(a.PartId, a.Name)"
                      [disabled]="!a.PartId">
                Stiahnuť
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Authorization Section for Delivery Notifications -->
  <div *ngIf="isDeliveryNotification()" class="govuk-!-margin-top-6">
    <h3 class="govuk-heading-s">Autorizácia správy</h3>
    
    <div class="govuk-inset-text govuk-!-margin-bottom-3" *ngIf="authorizeSuccess()">
      <p class="govuk-body govuk-!-margin-bottom-0">{{ authorizeSuccess() }}</p>
    </div>
    
    <button type="button"
            class="govuk-button"
            (click)="authorize()"
            [disabled]="authorizing() || authorizeSuccess()">
      {{ authorizing() ? 'Preberám...' : 'Prevziať' }}
    </button>
  </div>
</article>

<div *ngIf="!loading() && !detail()" class="govuk-inset-text">
  Vyberte správu zo zoznamu.
</div>